import {isCitationAlreadyAdded} from './buildCitationFromEvidence';
import {getEvidenceDedupeKey} from './buildSupportingEvidenceRows';
import {getCoverageForClaim} from './getClaimCoverage';

/**
 * Build deduped suggested-evidence rows for a claim from V4 backend suggestions.
 *
 * @param {Object|null|undefined} claim
 * @param {Array} references Added references for the mark
 * @param {Array} [suggestedReferences] Backend V4 suggestions from Y.Doc
 * @returns {Array<{
 *   referenceId: string|null,
 *   reference: null,
 *   corpusEntry: null,
 *   citation: Object,
 *   source: 'backend',
 *   claimCoverage: number|null,
 * }>}
 */
export function buildSuggestedEvidenceRows(claim, references = [], suggestedReferences = []) {
    const seen = new Set();
    const rows = [];

    (Array.isArray(suggestedReferences) ? suggestedReferences : []).forEach((citation) => {
        if (!citation || isCitationAlreadyAdded(citation, references)) return;
        const coverage = getCoverageForClaim(citation, claim?.id);
        if (coverage == null) return;

        const referenceId = citation.referenceId || citation.localId || null;
        const key = getEvidenceDedupeKey(citation, referenceId || '');
        if (seen.has(key)) return;
        seen.add(key);

        rows.push({
            referenceId,
            reference: null,
            corpusEntry: null,
            citation,
            source: 'backend',
            claimCoverage: coverage,
        });
    });

    rows.sort((a, b) => (b.claimCoverage || 0) - (a.claimCoverage || 0));
    return rows;
}
